__turbopack_context__.v({
  "bottomStrip": "styles-module__aqiMBa__bottomStrip",
  "bottomStripContact": "styles-module__aqiMBa__bottomStripContact",
  "brandCol": "styles-module__aqiMBa__brandCol",
  "col": "styles-module__aqiMBa__col",
  "colHeader": "styles-module__aqiMBa__colHeader",
  "colLink": "styles-module__aqiMBa__colLink",
  "colLinks": "styles-module__aqiMBa__colLinks",
  "content": "styles-module__aqiMBa__content",
  "root": "styles-module__aqiMBa__root",
  "small": "styles-module__aqiMBa__small",
  "socialIcon": "styles-module__aqiMBa__socialIcon",
  "socialRow": "styles-module__aqiMBa__socialRow",
  "tagline": "styles-module__aqiMBa__tagline",
  "top": "styles-module__aqiMBa__top",
});
